import created from './lib/mixins/created';
import computed from './lib/mixins/computed';
import methods from './lib/mixins/methods';
import registerVuexModule from './lib/state/register-vuex-module';
import Vuex from 'vuex';

const mixinComputed = options => {
    let superAdminRole = options.superAdminRole || 'super_admin';

    return Object.assign(computed, {
        superAdminRole() {
            return superAdminRole;
        },
    });
};

const Auth = {
    install(Vue, options) {
        if (!(options.store instanceof Vuex.Store)) {
            return new TypeError('Store parameters must be instanceof Vuex');
        }

        let namespace = options.namespace || 'Auth';
        Vue.prototype.$authPluginNamespace = namespace;

        registerVuexModule(options.store, namespace);

        Vue.mixin({
            computed: mixinComputed(options),
            created: created,
            methods: methods,
        });
    },
};

export default Auth;



// WEBPACK FOOTER //
// ./resources/assets/js/auth/index.js